module.exports = __webpack_public_path__ + "media/common/img/linkio_robo-85f4e1b6eb94008854510faf89434874.svg";